<template>
  <div class="admin-layout">
    <!-- 顶部系统名称栏 -->
    <header class="header">
      <div class="system-name" @click="goHome()">凯尚设计</div>
      <!-- <div class="system-button">
        <button class="back-button" @click="goHome()">返回首页</button>
      </div> -->
    </header>

    <!-- 左侧菜单栏 -->
    <aside class="sidebar">
      <nav class="menu">
        <div v-for="item in menuItems" :key="item.path" class="menu-item">
          <!-- 父级菜单 -->
          <div class="menu-title" @click="handleMenuClick(item)" :class="{ active: isMenuActive(item) }">
            {{ item.title }}
            <span v-if="item.children" class="arrow" :class="{ rotated: activeMenu === item.path }"></span>
          </div>

          <!-- 子菜单 -->
          <transition name="slide">
            <div v-show="activeMenu === item.path && item.children" class="sub-menu">
              <router-link v-for="child in item.children" :key="child.path" :to="child.path" class="sub-item"
                active-class="sub-item-active" @click="addTabFromMenu(child)">
                {{ child.title }}
              </router-link>
            </div>
          </transition>
        </div>
      </nav>
    </aside>

    <!-- 主内容区 -->
    <div class="main-container">
      <!-- 标签页区域 -->
      <div class="tabs-container" v-if="tabs.length > 0">
        <div class="tabs-wrapper">
          <div v-for="tab in tabs" :key="tab.fullPath" class="tab" :class="{ active: isActiveTab(tab) }"
            @click="switchTab(tab)">
            <span>{{ tab.title }}</span>
            <span class="close-tab" @click.stop="closeTab(tab)" v-if="tabs.length > 0">
              ×
            </span>
          </div>
        </div>
      </div>

      

      <!-- 页面内容区域 -->
      <main class="content">
        <!-- 使用 keep-alive 缓存页面 -->
         <div v-if="tabs.length === 0" class="nodata">
          <img src="@/assets/no_data.png" alt="" class="nodata_img">
          <span class="nodata_text">请选择左边菜单栏</span>
        </div>
        <!-- 使用 keep-alive 缓存页面 -->
        <router-view v-slot="{ Component }" v-else>
    <keep-alive :include="cachedComponents">
      <component :is="Component" />
    </keep-alive>
  </router-view>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const activeMenu = ref('');
const tabs = ref([]);

// 缓存的组件名称列表
const cachedComponents = ref([]);

// 菜单数据结构
const menuItems = [
  {
    title: '用户管理',
    path: 'userManage',
    children: [
      { title: '账号管理', path: '/houseCart/userManage',name: 'UserManage' },
      { title: '白名单管理', path: '/houseCart/whiteListManage',name: 'WhiteListManage' },
    ]
  },
  {
    title: '别墅管理',
    path: 'houseManage',
    children: [
      { title: '创建别墅', path: '/houseCart/houseManage' ,name:'HouseManage'}
    ]
  }
];

// 获取路由完整信息（包括参数）
const getRouteFullInfo = () => {
  // 获取当前路由的标题
  let title = '未知页面';
  if (route.meta && route.meta.title) {
    title = route.meta.title;
  } else {
    // 在菜单中查找标题
    for (const item of menuItems) {
      if (item.path === route.path) {
        title = item.title;
        break;
      }
      if (item.children) {
        const child = item.children.find(c => c.path === route.path);
        if (child) {
          title = child.title;
          break;
        }
      }
    }
  }

  // 如果是详情页，添加标识信息
  if (route.path.includes('houseDetailManage') && (route.query.userId || route.params.userId)) {
    // const userId = route.query.userId || route.params.userId;
    // title = `用户详情-${userId}`;
    title = `别墅详情`;
  }

  if (route.path.includes('loginRecord') && (route.query.mobile || route.params.mobile)) {
    // const mobile = route.query.mobile || route.params.mobile;
    // title = `登录记录-${mobile}`;
        title = `登录记录`;

  }



  // 生成组件缓存key
  const cacheKey = route.name ? `${route.name}${route.fullPath}` : route.fullPath;

  return {
    title,
    path: route.path,
    fullPath: route.fullPath, // 包含查询参数的完整路径
    query: route.query,
    params: route.params,
    name: route.name,
    cacheKey // 用于组件缓存的唯一标识
  };
};

// 计算需要缓存的组件名称
const updateCachedComponents = () => {
  cachedComponents.value = tabs.value
    .filter(tab => tab.name) // 只缓存有name的路由组件
    .map(tab => tab.name);
};

// 判断标签页是否激活
const isActiveTab = (tab) => {
  return tab.fullPath === route.fullPath;
};

// 从菜单添加标签页
const addTabFromMenu = (menuItem) => {
  const existingTab = tabs.value.find(tab => tab.path === menuItem.path && Object.keys(tab.query).length === 0);
  if (!existingTab) {
    tabs.value.push({
      title: menuItem.title,
      path: menuItem.path,
      fullPath: menuItem.path,
      query: {},
      params: {},
      name: menuItem.name
    });
    updateCachedComponents();
  }
};

// 切换标签页
const switchTab = (tab) => {
  if (tab.fullPath && tab.fullPath !== route.fullPath) {
    router.push(tab.fullPath);
  }
};

const goHome = () => { 
  router.push('/');
};

// 关闭标签页
const closeTab = (tabToClose) => {

  const index = tabs.value.findIndex(tab => tab.fullPath === tabToClose.fullPath);
  if (index !== -1) {
    // 从缓存组件列表中移除
    if (tabToClose.name) {
      const cacheIndex = cachedComponents.value.indexOf(tabToClose.name);
      if (cacheIndex !== -1) {
        cachedComponents.value.splice(cacheIndex, 1);
      }
    }

    tabs.value.splice(index, 1);

    // 如果关闭的是当前激活的标签页，则跳转到第一个标签页
    if (tabToClose.fullPath === route.fullPath && tabs.value.length > 0) {
      router.push(tabs.value[0].fullPath);
    }

    updateCachedComponents();
    if (tabs.value.length === 0) {
      router.push('/houseCart');
    }

  }
};

// 判断菜单是否激活
const isMenuActive = (item) => {
  if (item.children) {
    // 对于有子菜单的项，检查当前路由是否匹配任何子项
    return item.children.some(child => route.path === child.path);
  } else {
    // 对于无子菜单的项，直接匹配路径
    return route.path === item.path;
  }
};

// 处理菜单点击事件
const handleMenuClick = (item) => {
  if (item.children) {
    toggleSubMenu(item);
  } else {
    router.push(item.path);
    addTabFromMenu(item);
  }
};

// 切换子菜单展开状态
const toggleSubMenu = (item) => {
  if (item.children) {
    activeMenu.value = activeMenu.value === item.path ? '' : item.path;
  } else {
    router.push(item.path);
    // 添加到标签页
    addTabFromMenu(item);
  }
};

// 根据当前路由自动展开对应的父级菜单并添加标签页
const expandMenuByRoute = () => {
  // 获取当前路由的完整信息
  const routeInfo = getRouteFullInfo();
  console.log(routeInfo.fullPath);
  if('/houseCart'===routeInfo.fullPath){
    return;
  }
  // 添加当前路由到标签页（如果还没有的话）
  const existingTab = tabs.value.find(tab => tab.fullPath === routeInfo.fullPath);
  if (!existingTab) {
    tabs.value.push(routeInfo);
    updateCachedComponents();
  } else {
    // 更新现有标签页的信息
    existingTab.title = routeInfo.title;
  }

  // 展开对应的菜单项
  for (const item of menuItems) {
    if (item.children) {
      if (item.children.some(child => child.path === route.path)) {
        activeMenu.value = item.path;
        break;
      }
    } else {
      if (item.path === route.path) {
        activeMenu.value = '';
        break;
      }
    }
  }
};

// 监听路由变化
watch(() => route.fullPath, () => {
  expandMenuByRoute();
});

onMounted(() => {
  expandMenuByRoute();
});
</script>

<style scoped>
.admin-layout {
  display: flex;
  height: 100vh;
  font-family: 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 顶部系统名称栏 */
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #fff;
  color: #2b82cf;
  display: flex;
  align-items: center;
  padding: 0 24px;
  padding-left: 70px;
  font-size: 16px;
  box-shadow: 0 4px 8px 0 hsla(0, 0%, 85.9%, .5);
  z-index: 1000;
}

.system-name {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
}
.system-button{
  position: absolute;
  right: 180px;
  top: 15px;
}
.back-button{
  width: 90px;
  height: 35px;
  background: #2b82cf;
  color: #fff;
  border: #2b82cf;
  border-radius: 4px;
  font-size: 14px;
}

/* 侧边栏样式 */
.sidebar {
  width: 200px;
  background: white;
  color: #333;
  padding: 20px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.06);
  z-index: 100;
  margin-top: 60px;
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.menu-item {
  margin-bottom: 2px;
}

.menu-title {
  padding: 12px 24px;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  line-height: 24px;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s;
  font-weight: 500;
  color: #555;
}

.menu-title:hover {
  color: #2b82cf;
}

.menu-title.active {
  color: #2b82cf;
}

.arrow {
  transition: transform 0.3s ease;
  border: solid #777;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  padding: 4px;
  transform: rotate(-135deg);
}

.arrow.rotated {
  transform: rotate(45deg);
   border-color: #2b82cf;;
}

/* 子菜单过渡效果 */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-out;
  max-height: 200px;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}

/* 子菜单样式 */
.sub-menu {
  overflow: hidden;
  background: white;
  margin-top: 2px;
  /* padding-left: 36px;9 */
}

.sub-item {
  display: block;
  padding: 10px 20px;
  text-decoration: none;
  color: #555;
  transition: all 0.2s;
  margin: 2px 0;
  border-radius: 4px;
  font-size: 14px;
}

.sub-item:hover,
.sub-item-active {
  color: #2b82cf;
}

/* 主容器 */
.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 60px;
}

/* 标签页样式 */
.tabs-container {
  margin-top: 20px;
  background: #fff;
  padding: 0 20px;
  position: relative;
  /* border-bottom: 1px solid #e2e8f0; */
}

.tabs-wrapper {
  display: flex;
  align-items: center;
  height: 46px;
  overflow-x: auto;
  position: relative;
  z-index: 2;
}

.tab {
  display: flex;
  align-items: center;
  padding: 0 8px;
  margin-right: 6px;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  border: 1px solid #2b82cf;
  border-bottom: 1px solid #2b82cf;
  position: relative;
  height: 36px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
}

.tab.active {
  background: #2b82cf;
  border: 1px solid #2b82cf;
  border-bottom: 1px solid white;
  margin-bottom: -1px;
  font-weight: 500;
  color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
  z-index: 3;
}

.tab:hover:not(.active) {
  background: #f1f5f9;
}

.close-tab {
  margin-left: 5px;
  padding: 2px 2px;
  font-size: 18px;
  font-weight: normal;
  border-radius: 3px;
}

.close-tab:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

/* 主内容区 */
.content {
  flex: 1;
  /* padding: 24px; */
  overflow-y: auto;
  background: #ffffff;
  /* margin: 16px; */
  /* border-radius: 8px; */
  /* box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05); */
}

.nodata{
  margin-top: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nodata_img{
  width: 55px;
  height: auto;
}

.nodata_text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
  color: #cacaca;
  margin-top: 10px;
}

@media (max-width: 768px) {

  .system-name {
    margin-left: 100px;
  }
  .sidebar {
    width: 100px;
  }
  .menu-title{
    font-size: 10px;
  }
  .sub-item {
    font-size: 10px;
  }
  .arrow {
    border-width: 0 0.5px 0.5px 0;
    padding: 2px;
  }
  .tabs-wrapper {
    height: 30px;
  }
  .tabs-container {
    padding: 0 12px;
  }
  .tab {
    padding: 0 4px;
    font-size: 10px;
    height: 25px;
  }
}
</style>
